


















































import { Component, Prop, Vue } from 'vue-property-decorator';
import VueTagsInput from '@johmun/vue-tags-input';

import { GenericItem } from '@/models/items/generic-item-model';
import { ListModel } from '@/models/list-model';
import { ItemModelUtil } from '@/model-utils/item-model-util';
import SmallItemCard from '@/components/item-cards/SmallItemCard.vue';
import { UserModule } from '@/store/modules/user';

@Component({ components: { SmallItemCard, VueTagsInput } })
export default class AddItem_Step3 extends Vue {
  @Prop(GenericItem) public item: GenericItem;
  @Prop(ListModel) public list: ListModel;
  @Prop(Boolean) public editMode: boolean;

  public tag = '';
  public tags: any[] = [];

  mounted() {
    if (this.item.tags) {
      this.tags = this.item.tags
        .filter(t => !!t)
        .map(t => {
          return { text: t };
        });
    }
  }

  public async onSubmit() {
    const isValid = await this.$validator.validate();
    if (isValid) {
      if (this.editMode) {
        ItemModelUtil.updateItem(this.item).then(() =>
          this.$router.push(this.item.link)
        );
      } else if (this.list) {
        const savedItem = await ItemModelUtil.addItemToList(
          this.item,
          this.list,
          UserModule.userProfile
        );
        this.$router.push(savedItem.link);
      } else {
        this.$emit('go-to-next-step', {
          item: this.item
        });
      }
    }
  }
}
